import React, { Component } from 'react'
import Container from '../common/application_container'
import CarrierTable from './carrierTable'

export default class CarrierIndex extends Component {
    render() {
        return (
            <div>
                <Container title="Carrier" title1="Section" icon="icon-drawer3">
                    <CarrierTable />
                </Container>
            </div>
        )
    }
}
